import React, { useContext, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AccountContext } from '../../Accounts';
import { DataTypeContext } from '../../DataTypes';
import LoginForm from './LoginForm';

const LandingPage = () => {
    const { dataTypes } = useContext(DataTypeContext);
    const { welcomeMessage } = dataTypes;
    const { logout } = useContext(AccountContext);

    // eslint-disable-next-line
    useEffect(() => { logout() }, []);

    return (
        <Col md={6} sm={12} className="mx-auto">
            {welcomeMessage && (
                <div className="card shadow-sm rounded p-4 mb-4">
                    <h6 className="mb-0" dangerouslySetInnerHTML={{ __html: welcomeMessage }}></h6>
                </div>
            )}
            <div className="card shadow-sm rounded p-4">
                <LoginForm />
            </div>
        </Col>
    );
};

export default LandingPage;
